import { schema } from 'normalizr';

export const dashboardSchema = new schema.Entity('dashboards', {}, { idAttribute: 'DashboardTypeId' });

export const dashboardListSchema = [dashboardSchema];

export const dashboardResultSchema = new schema.Entity('dashboardResults', {}, { idAttribute: 'FormulaReviewId' });
